<template>
  <div>
    <div
      class="image-text-set-container"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <div v-if="imageArticleListFirstLine.length > 0" class="first-line">
        <span
          v-for="item in imageArticleListFirstLine"
          :key="item.id"
          class="image-text-set-item"
          :style="{
            'background-color': item.backgroundColor,
            color: configDataForm.fontColor,
          }"
        >
          <span class="item-icon">
            <el-image
              :src="item.iconFullUrl || noUpload"
              fit="cover"
            ></el-image>
          </span>
          <span class="item-title">{{ item.title }}</span>
          <span class="item-link">查看详细</span>
        </span>

        <span
          v-if="imageArticleListFirstLine.length < 5"
          class="image-text-set-item"
        >
          <span class="item-dot">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <span class="item-link">更多</span>
        </span>
      </div>
      <div v-if="imageArticleListSecondLine.length > 0" class="second-line">
        <span
          v-for="item in imageArticleListSecondLine"
          :key="item.id"
          class="image-text-set-item"
          :style="{
            'background-color': item.backgroundColor,
            color: configDataForm.fontColor,
          }"
        >
          <span class="item-icon">
            <el-image
              :src="item.iconFullUrl || noUpload"
              fit="cover"
            ></el-image>
          </span>
          <span class="item-title">{{ item.title }}</span>
          <span class="item-link">查看详细</span>
        </span>
        <span
          v-if="imageArticleListSecondLine.length < 5"
          class="image-text-set-item"
        >
          <span class="item-dot">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <span class="item-link">更多</span>
        </span>
      </div>

      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <image-text-set-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></image-text-set-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import ImageTextSetEditForm from './ImageTextSetEditForm.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});
// console.log('props-ImageTextSetTwo:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
 query: '?url',
});
// 直接获取目标图片 URL
const noUpload = images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      iconName: '示例图片2.jpg',
      iconFileKey: 'icon1',
      title: '任务管理及绩效管理',
      backgroundColor: '#fbbe2d',
      fontColor: '#ffffff',
      linkType: 2,
      linkUrl: 'https://www.baidu.com',
    },
    {
      sortNum: 2,
      iconName: '示例图片2.jpg',
      iconFileKey: 'icon2',
      title: '养老院管理系统',
      backgroundColor: '#1e93ea',
      fontColor: '#ffffff',
      linkType: 1,
      linkUrl: '/article-list/132',
    },
    {
      sortNum: 2,
      iconName: '示例图片2.jpg',
      iconFileKey: 'icon2',
      title: '移动电子商务',
      backgroundColor: '#a478db',
      fontColor: '#ffffff',
      linkType: 1,
      linkUrl: '/article-list/132',
    },
    {
      sortNum: 2,
      iconName: '示例图片2.jpg',
      iconFileKey: 'icon2',
      title: '幼儿园管理系统',
      backgroundColor: '#ef5e61',
      fontColor: '#ffffff',
      linkType: 1,
      linkUrl: '/article-list/132',
    },
    {
      sortNum: 2,
      iconName: '示例图片2.jpg',
      iconFileKey: 'icon2',
      title: '职业培训管理系统',
      backgroundColor: '#61b400',
      fontColor: '#ffffff',
      linkType: 1,
      linkUrl: '/article-list/132',
    },
  ],
});
if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);
}
/**
 * 第一行显示
 */
const imageArticleListFirstLine = configDataForm.value.items.slice(0, 5);
const imageArticleListSecondLine = configDataForm.value.items.slice(5, 9);

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};

/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .image-text-set-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 1200px;
    margin: 0 auto;
  }

  .first-line,
  .second-line {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  .image-text-set-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 220px;
    height: 200px;
    margin-right: 24px;
    margin-bottom: 50px;
    background-color: #ef5e61;
    border-radius: $website-radius-lg;
    transition: all $website-duration-normal $website-ease-out;

    &:hover {
      box-shadow: $website-shadow-lg;
      transform: translate3d(0, -10px, 0);
    }

    span {
      display: inline-block;
      font-size: 16px;
      color: #fff;
    }

    span.item-icon {
      width: 100%;
      height: 140px;
      overflow: hidden;
      border-radius: $website-radius-lg $website-radius-lg 0 0;

      :deep(.el-image) {
        width: 100%;
        height: 140px;
      }
    }

    span.item-link {
      width: 90px;
      height: 26px;
      font-size: 13px;
      line-height: 26px;
      text-align: center;
      border: 0.5px solid #fff;
      border-radius: $website-radius-full;
      transition: all $website-duration-fast $website-ease-out;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    span.item-dot {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100px;
    }

    span.item-dot > span {
      position: relative;
      top: 30px;
      width: 13px;
      height: 13px;
      margin: auto 8px;
      background-color: #fff;
      border-radius: 50%;
    }
  }
}

/* 移动端样式 */
@include mobile {
  .image-text-set-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 4vw;
    margin: 0;
  }

  .first-line,
  .second-line {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 3vw;
  }

  .image-text-set-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 42vw;
    height: 40vw;
    margin-right: 0;
    margin-bottom: 3vw;
    background-color: #ef5e61;
    border-radius: 3vw;
    transition: all $website-duration-fast $website-ease-out;

    &:active {
      transform: scale(0.95);
    }

    span {
      display: inline-block;
      font-size: 3.5vw;
      color: #fff;
    }

    span.item-icon {
      width: 42vw;
      height: 22vw;
      overflow: hidden;
      border-radius: 3vw 3vw 0 0;

      :deep(.el-image) {
        width: 42vw;
        height: 22vw;
      }
    }

    span.item-link {
      width: 20vw;
      height: 6.5vw;
      font-size: 3vw;
      line-height: 6.5vw;
      text-align: center;
      border: 0.5px solid #fff;
      border-radius: $website-radius-full;
    }

    span.item-dot {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 20vw;
    }

    span.item-dot > span {
      position: relative;
      top: 6vw;
      width: 3vw;
      height: 3vw;
      margin: auto 2vw;
      background-color: #fff;
      border-radius: 50%;
    }
  }
}

:deep(.el-color-picker__trigger) {
  width: 100px;
}
</style>
